module.exports = __webpack_public_path__ + "static/media/rainbow.7175df60.png";